<template>
  <div class="form-group form-check p-d-flex p-flex-row p-flex-nowrap p-jc-center p-ai-stretch">
    <div class="pos-service p-mr-3 p-ml-3" v-for="service in services" :key="service.key">
      <Checkbox :id="service.key" name="service" :value="service.key" v-model="selectedServices" @change="$emit('update-services', service.key)" />
      <label :for="service.key">{{service.name}}</label>
    </div>
  </div>
</template>

<script>
const servicesList = [{name: 'Décalaminage moteur', key: 'descaling'}, {name: 'Réparation de vitres', key: 'glazing_repair'}];

export default {
  name: "SearchServices.vue",
  props: {
    searchServices: {
      type: Array,
      default: new Array()
    }
  },
  data() {
    return {
      services: servicesList,
      selectedServices: this.searchServices
    }
  }
}
</script>

<style scoped>
.pos-service label {
  margin-left: 10px;
}
.pos-service {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
</style>
